<template>
  <nx-taxonomy-selector-by-media
    class="mt-3 mb-4"
    :label="label"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :value="value"
    :disabled="disabled"
    v-bind="$attrs"
    v-validate:value="validation"
    data-vv-validate-on="input|blur"
    :error-messages="errorMessages"
    :required="required"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  ></nx-taxonomy-selector-by-media>
</template>

<script>
import Storable from '@/mixins/storable';
import NxTaxonomySelectorByMedia from '@/modules/taxonomy/selector/SelectorByMedia';
import FormElement from '@/modules/form/mixins/form-element';
import toast from '@/modules/toast/services';
import { isEmpty, uniqBy } from 'lodash';
import api from '../api';

export default {
  name: 'nx-central-newsroom-media-taxonomy-sendings',
  mixins: [FormElement, Storable],
  inject: {
    $getParentEditor: { default: null },
  },
  components: {
    NxTaxonomySelectorByMedia,
  },
  props: {
    value: {
      type: Array,
    },
  },
  computed: {
    storePath() {
      return this.$getParentEditor ? this.$getParentEditor().storePath : 'content/editor';
    },
    contentDraft() {
      return this.getters.draft;
    },
  },
  methods: {
    onInput(inputValue) {
      this.$parentForm.updateField(this.name, inputValue);
      this.$emit('input', inputValue);
    },
    onBlur(blurValue) {
      this.flags.focused = false;
      this.$emit('blur', blurValue);
    },
    async syncWithTaxonomies(taxonomyIds) {
      try {
        const result = await Promise.all(taxonomyIds.map(async (taxonomyId) => {
          const { mappedTaxonomyIds } = await api.getCentralNewsroomTaxonomyMappings(taxonomyId);
          return mappedTaxonomyIds;
        }));

        if (result.length > 0) {
          this.$parentForm.updateField(this.name, uniqBy(result.flat(), taxon => taxon.id));
          toast.success('message.centralNewsroom.taxonomySendings.success');
        }
      } catch (e) {
        toast.notify('message.centralNewsroom.taxonomySendings.error');
        console.error(e);
      }
    },
    subscribeToChannelDraftUpdates() {
      // Subscribe to mutation
      this.$store.subscribe((mutation) => {
        if (mutation.type !== `${this.storeName}/UPDATE_CHANNEL_DRAFT`
          || mutation.payload.channel !== 'master') {
          return;
        }

        // Sync with payload mainTaxonomyId and draft secondaryTaxonomyIds
        if (Object.keys(mutation.payload.fields).includes('mainTaxonomyId')) {
          this.syncWithTaxonomies([
            mutation.payload.fields.mainTaxonomyId,
            ...(this.contentDraft.secondaryTaxonomyIds || []).map(taxon => taxon.id),
          ].filter(Boolean));
        }

        // Sync with payload secondaryTaxonomyIds and draft mainTaxonomyId
        if (Object.keys(mutation.payload.fields).includes('secondaryTaxonomyIds')) {
          this.syncWithTaxonomies([
            this.contentDraft.mainTaxonomyId.id,
            ...mutation.payload.fields.secondaryTaxonomyIds || [],
          ].filter(Boolean));
        }
      });
    },
  },
  async mounted() {
    this.subscribeToChannelDraftUpdates();
    if (!isEmpty(this.value)) {
      return;
    }

    if (this.contentDraft
      && this.contentDraft.mainTaxonomyId
      && this.contentDraft.mainTaxonomyId.id) {
      this.syncWithTaxonomies([this.contentDraft.mainTaxonomyId.id]);
    }
  },
};
</script>
